import React, { useEffect, useState, useRef } from "react";
import Header from '../../components/header/Header';
import Sidebar from '../../components/sidebar/Sidebar';
import { useNavigate } from "react-router-dom";
import { getEarningsListing } from "../../api/apiHandler";
import { showMessage, showErrorMessage, convertUTCToLocal } from "../common/Utils";
import $ from 'jquery';
import 'magnific-popup';
import "parsleyjs/src/parsley.css";
import "parsleyjs";
import 'select2';
import 'select2/dist/css/select2.min.css';
import DataTable from "react-data-table-component";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export function ClosedPositions() {

    const customStyles = {
        headCells: {
            style: {
                backgroundColor: '#B6A878',
                color: '#000000',
                fontWeight: 'bold',
                fontSize: '14px',
                textAlign: 'center',
                padding: '10px',
            },
        },
        cells: {
            style: {
                padding: '8px',
                textAlign: 'center',
                borderBottom: '1px solid #e0e0e0',
            },
        },
    };

    let navigate = useNavigate();
    const auth = localStorage.getItem('token');
    const timezone = localStorage.getItem('timezone');
    const typeSelectRef = useRef(null);
    const sideSelectRef = useRef(null);
    const initialized = useRef(false); // Prevents multiple initializations

    // Redirect to login if not logged in
    if (!auth) {
        navigate('/login');
    }

    const [data, setData] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");
    const [pagination, setPagination] = useState({ page: 1, perPage: 50 });
    const [sortField, setSortField] = useState("id");
    const [sortOrder, setSortOrder] = useState("DESC");
    const [filters, setFilters] = useState({ order_type: 'all', order_side: 'all' });
    const [totals, setTotals] = useState([{ total_commission: 0, total_cost: 0, total_financing: 0, final_total: 0 }]);

    // Fetch data from server
    const fetchData = async () => {
        setLoading(true);
        try {
            
            const userReq = {
                page: pagination.page,
                per_page: pagination.perPage,
                search,
                sort: sortField,
                order: sortOrder,
                status: filters.order_status,
                order_type: filters.order_type,
                side: filters.order_side
            }
            console.log("REQUEST : ", userReq);
            const response = await getEarningsListing(userReq);
            if (parseInt(response.code) === 1) {
                let finalCalculate = [{ total_commission: 0, total_cost: 0, total_financing: 0, final_total: 0 }];
                console.log("Response received...")
                response.data.items.forEach(element => {
                    finalCalculate[0].total_commission += parseFloat(element.commission);
                    finalCalculate[0].total_cost += parseFloat(element.cost);
                    finalCalculate[0].total_financing += parseFloat(element.financing);
                    finalCalculate[0].final_total += (parseFloat(element.commission) + parseFloat(element.cost) + parseFloat(element.financing));
                });
                console.log("finalCalculate : ", finalCalculate);
                setTotals(finalCalculate);
                console.log("Totals Assigned...")
                setData(response.data.items);
                console.log("Data set...")
                setTotalRows(response.data.totalcount);
            } else {
                showErrorMessage(response.message);
            }
        } catch (error) {
            showErrorMessage("Something went wrong loading closed position, please try again later");
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchData();  // ✅ Ensure fetching happens when dependencies change
    }, [pagination, search, sortField, sortOrder]);

    // ✅ Trigger `fetchData()` when `filters` change
    useEffect(() => {
        if (!initialized.current) {
            initialized.current = true;
    
            // Delay to allow React to fully render the select options before initializing select2
            setTimeout(() => {
                $(typeSelectRef.current).select2();
                $(sideSelectRef.current).select2();
    
                // Trigger initial value set
                $(typeSelectRef.current).val(filters.order_type).trigger('change');
                $(sideSelectRef.current).val(filters.order_side).trigger('change');
    
                // Set up change handler
                $(typeSelectRef.current).on("change", function () {
                    const value = $(this).val();
                    setFilters(prev => ({ ...prev, order_type: value }));
                });
                $(sideSelectRef.current).on("change", function () {
                    const value = $(this).val();
                    setFilters(prev => ({ ...prev, order_side: value }));
                });
            }, 1000);
        }
        fetchData(filters); // Fetch data after filters update
    }, [filters]);

    // Handle pagination
    const handlePageChange = (page) => {
        setPagination((prev) => ({ ...prev, page }));
    };
    
    const handlePerRowsChange = (perPage) => {
        setPagination({ page: 1, perPage });
    };
    
    // Handle sorting
    const handleSort = (column, sortDirection) => {
        setSortField(column.sortableField); // Field to sort by
        setSortOrder(sortDirection.toUpperCase()); // ASC or DESC
    };

    const formatNumber = (num) => {
        if (!num) return "0";

        const parsed = parseFloat(num);
        return parsed % 1 === 0 
            ? parsed.toFixed(0) 
            : parsed.toFixed(2).replace(/\.?0+$/, "");
    };

    const exportToExcel = async () => {
        const today = new Date().toISOString().slice(0, 10);
        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet("Closed Positions");
    
        const title = `Closed Positions - ${today}`;
        const headers = [
            "GROUP-ORDER-ID", "USER NAME", "TYPE", "SIDE", "QTY", "SYMBOL",
            "TOTAL", "COMMISSION", "COST", "FINANCING", "TOTAL-EARNING", "CREATED AT"
        ];
        
        // Title row
        sheet.mergeCells('A1:K1');
        const titleRow = sheet.getCell('A1');
        titleRow.value = title;
        titleRow.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'B6A878' } };
        titleRow.font = { bold: true, size: 14 };
        titleRow.alignment = { vertical: 'middle', horizontal: 'center' };
    
        // Header row
        const headerRow = sheet.addRow(headers);
        headerRow.eachCell(cell => {
            cell.font = { bold: true, color: { argb: 'FFFFFF' } };
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '000000' } };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });
        
        // Data rows
        data.forEach((rowData, index) => {
            const headers = [
                "GROUP-ORDER-ID", "USER NAME", "TYPE", "SIDE", "QTY", "SYMBOL",
                "TOTAL", "COMMISSION", "COST", "FINANCING", "TOTAL-EARNING", "CREATED AT"
            ];
            const row = [
                rowData.group_order_id,
                `${rowData.first_name} ${rowData.last_name}`,
                rowData.type,
                rowData.side,
                Number(rowData.quantity),
                rowData.symbol,
                Number(rowData.totalamount),
                Number(rowData.commission),
                Number(rowData.cost),
                Number(rowData.financing),
                Number(parseFloat(rowData.commission) + parseFloat(rowData.cost) + parseFloat(rowData.financing)),
                convertUTCToLocal(rowData.created_at, timezone),
            ];
            const addedRow = sheet.addRow(row);
            const bgColor = (index % 2 === 0) ? 'FFFFFF' : 'E6F2FF';
            addedRow.eachCell(cell => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: bgColor }
                };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
            });

            [ 5, 7, 8, 9, 10, 11 ].forEach(colIndex => {
                const cell = addedRow.getCell(colIndex);
                cell.numFmt = '#,##0.00';
            });
        });
        
        if (totals?.length > 0) {
            const row = [
                '',
                '',
                '',
                '',
                '',
                '',
                '',
                Number(totals[0].total_commission),
                Number(totals[0].total_cost),
                Number(totals[0].total_financing),
                Number(totals[0].final_total),
                '',
            ];
            const addedRow = sheet.addRow(row);
            const bgColor = 'B6A878';
    
            [ 8, 9, 10, 11 ].forEach(colIndex => {
                const cell = addedRow.getCell(colIndex);
                cell.numFmt = '#,##0.00';
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: bgColor }
                };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
            });   
        }

        // Set column widths (~15% each)
        sheet.columns.forEach(column => {
            column.width = 25;
        });
    
        // Generate Excel file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/octet-stream' });
        saveAs(blob, `Closed_Positions_${today}.xlsx`);
    };

    const handleClearFilter = () => {

        setFilters({ order_type: 'all', order_side: 'all' });
        // Trigger initial value set
        $(typeSelectRef.current).val('all').trigger('change');
        $(sideSelectRef.current).val('all').trigger('change');
    }

    return (
        <>
            <Header />
            <Sidebar />
            <section className="content">
                <div className="block-header">
                    <div className="row">
                        <div className="col-lg-7 col-md-6 col-sm-12">
                            <h2>Closed Positions</h2>
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-12">
                            <ul className="breadcrumb float-md-right">
                                <li className="breadcrumb-item">
                                    <a href="/authpanel/dashboard">
                                    <i className="zmdi zmdi-home" />
                                        Dashboard
                                    </a>
                                </li>
                                <li className="breadcrumb-item active">Closed Positions</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 col-lg-12 col-xl-12">
                            <div className="card">
                                <div className="body">
                                    <div className="table-responsive">
                                        <div className="toolbar">
                                            <div className="row" style={{ marginRight: '0px' }}>
                                                <div className="col-md-2 col-lg-2 col-xl-2 mt-4">
                                                    <button className="btn btn-primary btn-sm" type="button" onClick={exportToExcel}>
                                                        Export
                                                    </button>
                                                </div>
                                                <div className="col-md-2 col-lg-2 col-xl-2">
                                                    <div className="form-group" style={{ marginBottom: '5px' }}>
                                                        <select ref={typeSelectRef} className="form-control" id="order_type" name="order_type" style={{ minWidth: '200px' }}>
                                                            <option value="all">All</option>
                                                            <option value="MARKET">MARKET</option>
                                                            <option value="LIMIT">LIMIT</option>
                                                            <option value="STOP">STOP</option>
                                                            <option value="OCO">OCO</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-2 col-lg-2 col-xl-2">
                                                    <div className="form-group" style={{ marginBottom: '5px' }}>
                                                        <select ref={sideSelectRef} className="form-control" id="order_side" name="order_side" style={{ minWidth: '200px' }}>
                                                            <option value="all">All</option>
                                                            <option value="BUY">BUY</option>
                                                            <option value="SELL">SELL</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-3 col-lg-3 col-xl-3">
                                                    <button type="button" onClick={handleClearFilter} className="btn btn-raised btn-primary btn-xs waves-effect m-t-25 ml-3">
                                                        CLEAR
                                                    </button>
                                                </div>
                                                <div className="col-md-3 col-lg-3 col-xl-3">
                                                    <div className="form-group" style={{ marginBottom: '5px' }}>
                                                        <input
                                                            type="text"
                                                            placeholder="🔍 Search..."
                                                            value={search}
                                                            onChange={(e) => setSearch(e.target.value)}
                                                            style={{
                                                                width: "100%",
                                                                padding: "10px 15px",
                                                                borderRadius: "25px",
                                                                border: "1px solid #ccc",
                                                                outline: "none",
                                                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                                fontSize: "14px",
                                                            }}
                                                            className="form-control mb-3"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <DataTable
                                            columns={[
                                                { name: "GROUP-ORDER-ID", selector: (row) => row.group_order_id, sortable: true, sortableField: "group_order_id", width: '18%' },
                                                { name: "USER NAME", selector: (row) => `${row.first_name} ${row.last_name}`, sortable: false, width: '12%' },
                                                { name: "TYPE", selector: (row) => {
                                                    if (row.type === 'MARKET') {
                                                        return <label className="label label-success label-xs">{row.type}</label>
                                                    } else if (row.type === 'STOP' || row.type === 'LIMIT') {
                                                        return <label className="label label-danger label-xs">{row.type}</label>
                                                    } else {
                                                        return <label className="label label-warning label-xs">{row.type}</label>
                                                    }
                                                }, sortable: false, width: '8%' },
                                                { name: "SIDE", selector: (row) => {
                                                    return (row.side === 'BUY') ? <label className="label label-success label-xs">{row.side}</label> : <label className="label label-warning label-xs">{row.side}</label>;
                                                }, sortable: false, width: '6%' },
                                                { name: "QTY", selector: (row) => row.quantity, sortable: true, sortableField: "quantity", width: '6%' },
                                                { name: "SYMBOL", selector: (row) => row.symbol, sortable: false, width: '7%' },
                                                { name: "TOTAL", selector: (row) => `${formatNumber(row.totalamount)} ${row.user_currency}`, sortable: false, width: '10%' },
                                                { name: "COMMISSION", selector: (row) => `${formatNumber(row.commission)} ${row.user_currency}`, sortable: false, width: '10%' },
                                                { name: "COST", selector: (row) => `${formatNumber(row.cost)} ${row.user_currency}`, sortable: false, width: '6%' },
                                                { name: "FINANCING", selector: (row) => `${formatNumber(row.financing)} ${row.user_currency}`, sortable: false, width: '10%' },
                                                { name: "TOTAL-EARNING", selector: (row) => <span>{formatNumber(parseFloat(row.commission) + parseFloat(row.cost) + parseFloat(row.financing))} {row.user_currency}</span>, sortable: false, width: '12%' },
                                                { name: "CREATED AT", selector: (row) => convertUTCToLocal(row.created_at, timezone), sortable: true, sortableField: "created_at", width: '15%' },
                                            ]}
                                            data={data || []}
                                            defaultSortField="id"
                                            defaultSortAsc={false}
                                            pagination
                                            paginationServer
                                            paginationTotalRows={totalRows}
                                            paginationRowsPerPageOptions={[10, 20, 50, 100]}
                                            paginationPerPage={50} // Default page size
                                            onChangePage={handlePageChange}
                                            onChangeRowsPerPage={handlePerRowsChange}
                                            onSort={handleSort}
                                            sortServer
                                            persistTableHead
                                            progressPending={loading}
                                            customStyles={customStyles}
                                            noDataComponent={<div style={{ textAlign: "center", padding: "20px", color: "#888" }}>No data found</div>}
                                        />
                                        {totals?.length > 0 && (
                                            <div className="table-footer-totals" style={{ marginTop: '20px', padding: '10px', background: '#f9f9f9', borderTop: '1px solid #ddd' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-around', fontWeight: 'bold' }}>
                                                    <span>Total Commission: {formatNumber(totals[0].total_commission)}</span>
                                                    <span>Total Cost: {formatNumber(totals[0].total_cost)}</span>
                                                    <span>Total Financing: {formatNumber(totals[0].total_financing)}</span>
                                                    <span>Total: {formatNumber(totals[0].final_total)}</span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}